import { Pipe, PipeTransform } from '@angular/core';
import { Position } from '@core/interfaces/position.interface';

@Pipe({
  name: 'centerPoint',
  standalone: true,
})
export class CenterPointPipe implements PipeTransform {
  public transform(
    start: Position,
    end: Position,
    direction: 'x' | 'y',
    isLoop = false,
    pathElement?: HTMLElement,
    suffix = 'px',
  ): string {
    if (start && end) {
      if (isLoop && direction === 'y') {
        const pathElementClientRect = pathElement?.getBoundingClientRect();

        if (start.y < end.y) {
          const connectionParentDiv = pathElement.closest('div');
          const yOffset = 112;

          return `${pathElementClientRect?.top - connectionParentDiv?.getBoundingClientRect()?.top + yOffset}${suffix}`;
        }

        const startPoint = start[direction] > end[direction] ? end : start;
        const position = start[direction] >= end[direction] ? 1 : -1;

        const height =
          (pathElement && startPoint[direction] + pathElementClientRect?.height * position) || start[direction];

        return `${height}${suffix}`;
      }

      return `${(start[direction] + end[direction]) / 2}${suffix}`;
    }

    return null;
  }
}
